import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import {
  fetchAnonymousMessagesList,
  clearAnonymousMessagesList,
  deleteAnonymousMessage,
  clearDeleteAnonymousMessageStatus,
  fetchAnonymousMessagesCsv,
  clearFetchAnonymousMessagesCsv,
} from 'redux/anonymous-messages/actions';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import ProSectionPlaceholder
  from 'components/common/pro-placeholders/ProSectionPlaceholder';
import CommonTable
  from 'components/elements/tables/common-table/CommonTable';
import AnonymousMessagesListItem
  from 'components/dashboard/anonymous-messages-content/AnonymousMessagesListItem';
import DownloadButton from 'components/elements/buttons/DownloadButton';
import Pagination
  from 'components/common/Pagination';
import CommonMessage
  from 'components/common/CommonMessage';

import { performDownload } from 'utils/common';

import './AnonymousMessagesList.css';

class AnonymousMessagesList extends Component {
  static propTypes = {
    me: PropTypes.object,
    fetchAnonymousMessagesList: PropTypes.func,
    clearAnonymousMessagesList: PropTypes.func,
    anonymousMessagesList: PropTypes.object,
    anonymousMessagesListError: PropTypes.object,
    deleteAnonymousMessageSuccess: PropTypes.object,
    deleteAnonymousMessageError: PropTypes.object,
    anonymousMessagesCsv: PropTypes.object,
  };
  static defaultProps = {
    me: null,
    fetchAnonymousMessagesList: null,
    clearAnonymousMessagesList: null,
    anonymousMessagesList: null,
    anonymousMessagesListError: null,
    deleteAnonymousMessageSuccess: null,
    deleteAnonymousMessageError: null,
    anonymousMessagesCsv: null,
  };

  state = {
    activePaginationPage: 0,
  };

  componentDidMount() {
    if (!this.props.anonymousMessagesList) {
      this.props.fetchAnonymousMessagesList();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.deleteAnonymousMessageSuccess &&
      prevProps.deleteAnonymousMessageSuccess !== this.props.deleteAnonymousMessageSuccess
    ) {
      this.props.fetchAnonymousMessagesList();
      setTimeout(() => {
        this.props.clearDeleteAnonymousMessageStatus();
      }, 500);
    }

    if (
      !prevProps.anonymousMessagesCsv &&
      this.props.anonymousMessagesCsv !== prevProps.anonymousMessagesCsv
    ) {
      const date = new Date();
      performDownload(
        `Messages_List_for_${this.props.me.username}_${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}.csv`,
        this.props.anonymousMessagesCsv
      );
      setTimeout(() => {
        this.props.clearFetchAnonymousMessagesCsv();
      }, 3000);
    }
  }

  componentWillUnmount() {
    this.props.clearAnonymousMessagesList();
  }

  handlePaginationPageClick = date => {
    const _date = date.selected + 1;
    this.props.fetchAnonymousMessagesList(_date);
    this.setState({ activePaginationPage: date.selected });
  };

  renderTableData = () => {
    const { me, anonymousMessagesList } = this.props;
    const isPro = me && me.subscription && me.subscription.ff_messages;

    if (!anonymousMessagesList) return null;

    return (
      <Translation>
        {(t) => (
          <div className="anonymous-messages-list-content">
            <CommonTable className="mobile-1024">
              <CommonTable.Header>
                <CommonTable.Cell>#</CommonTable.Cell>
                <CommonTable.Cell>{t("Text")}</CommonTable.Cell>
                <CommonTable.Cell>{t("Name")}</CommonTable.Cell>
                <CommonTable.Cell>{t("Email")}</CommonTable.Cell>
                <CommonTable.Cell>{t("Date Received")}</CommonTable.Cell>
                <CommonTable.Cell />
              </CommonTable.Header>
              {this.renderTableItem(anonymousMessagesList.results, isPro, anonymousMessagesList.count)}
            </CommonTable>

            {anonymousMessagesList && anonymousMessagesList.results &&
              anonymousMessagesList.results.length === 0 &&
              <CommonMessage info>{t("You don't have any messages yet…")}</CommonMessage>
            }

            <div className="table-footer">
              {anonymousMessagesList && anonymousMessagesList.count > 0 &&
                <DownloadButton onClick={this.props.fetchAnonymousMessagesCsv}>
                  {t("Export to CSV")}
                </DownloadButton>
              }
              {anonymousMessagesList && anonymousMessagesList.count > 30 && isPro &&
                <Pagination
                  containerClassName={'anonymous-messages-list-paginator'}
                  activeClassName={'active'}
                  pageCount={Math.ceil(anonymousMessagesList.count / 30)}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={this.handlePaginationPageClick}
                />
              }
            </div>
          </div>
        )}
      </Translation>
    );
  };

  renderTableItem = (tableItems, isPro, totalCount) => {
    if (tableItems.length === 0) return null;

    if (isPro) {
      return (
        <Fragment>
          {tableItems.map((i, index) => (
            <AnonymousMessagesListItem
              key={`anonymous_message_list_item_id_${i.id}`}
              item={i}
              index={index}
              activePaginationPage={this.state.activePaginationPage}
              deleteAnonymousMessage={this.props.deleteAnonymousMessage}
              isPro={isPro}
            />
          ))}
        </Fragment>
      );
    }
    if (!isPro) {
      let fakeData = [];
      const totalPageItems = 30;

      if (tableItems && tableItems.length > 2) {
        for (let i = 0; i < totalCount && i < totalPageItems; i += 1) {
          fakeData.push({
            created_at: '2020-12-15T02:50:52.692866+11:00',
            deleted_at: null,
            id: `fake_message_id_${i}`,
            message: 'Buy PRO to unlock this message'
          })
        }
      }

      const compareData = [
        ...tableItems,
        ...fakeData
      ].slice(0, totalCount > totalPageItems ? totalPageItems : totalCount);

      return (
        <Fragment>
          {compareData.map((i, index) => (
            <AnonymousMessagesListItem
              key={`anonymous_message_list_item_id_${i.id}`}
              item={i}
              index={index}
              activePaginationPage={this.state.activePaginationPage}
              deleteAnonymousMessage={this.props.deleteAnonymousMessage}
              isPro={isPro}
            />
          ))}
        </Fragment>
      );
    }
    return null;
  };

  render() {
    const { me, anonymousMessagesList } = this.props;

    if (!me) return null;

    return (
      <Translation>
        {(t) => (
          <DashboardFormSection
            className="anonymous-messages-list__component"
          >
            <div className="anonymous-messages-list-wrapper">
              <h4 className="title">{t("Messages")}</h4>
              {anonymousMessagesList && anonymousMessagesList.results &&
                (anonymousMessagesList.count - anonymousMessagesList.results.length ) > 0 && // anonymousMessagesList.results for starter plan always return 3
                me && me.subscription && !me.subscription.ff_messages &&                     // as it sliced on server side.
                <ProSectionPlaceholder                                                       // anonymousMessagesList.count always return the actual count of messages
                  key="anonymous_messages_list-pro-feature-key"
                  locked={me && me.subscription && !me.subscription.ff_messages}
                  className="anonymous-messages-list-pro-feature-placeholder"
                  text={<>{t("All messages are available on the PRO plan. Check it")}</>}
                />
              }

              {this.renderTableData()}
            </div>
          </DashboardFormSection>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    anonymousMessagesList: state.anonymousMessagesReducer.anonymousMessagesList,
    anonymousMessagesListError: state.anonymousMessagesReducer.anonymousMessagesListError,
    deleteAnonymousMessageSuccess: state.anonymousMessagesReducer.deleteAnonymousMessageSuccess,
    deleteAnonymousMessageError: state.anonymousMessagesReducer.deleteAnonymousMessageError,
    anonymousMessagesCsv: state.anonymousMessagesReducer.anonymousMessagesCsv,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchAnonymousMessagesList,
    clearAnonymousMessagesList,
    deleteAnonymousMessage,
    clearDeleteAnonymousMessageStatus,
    fetchAnonymousMessagesCsv,
    clearFetchAnonymousMessagesCsv,
  },
)(AnonymousMessagesList);
